import { render, staticRenderFns } from "./DdsUploadPrims.vue?vue&type=template&id=7db226d7&"
import script from "./DdsUploadPrims.vue?vue&type=script&lang=js&"
export * from "./DdsUploadPrims.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports